export default {
  create: {
    title: 'Adicionar',
    subtitle: 'Numerex',
  },
  edit: {
    title: 'Editar',
    subtitle: 'Numerex',
    button: {
      add: 'Novo jogo',
    },
  },
  list: {
    title: 'Numerex',
    subtitle: 'Lista',
    add: 'Novo jogo',
  },
  card: {
    title: 'Numerex',
    actions: 'Ações',
  },
  table: {
    title: 'Jogos Ativos',
    searchPlaceholder: 'Procurar por algo...',
  },
  form: {
    name: {
      label: 'Nome:',
      placeholder: 'Ex: Numerex Nível 1',
      invalid: 'Nome é obrigatório',
    },
    rows: {
      label: 'Linhas:',
    },
    columns: {
      label: 'Colunas:',
    },
    level: {
      label: 'Nível:',
      placeholder: 'Selecione o nível...',
    },
    generationMode: {
      label: 'Forma de geração:',
      placeholder: 'Selecione a forma...',
      options: {
        simple: 'Simples',
        distribution: 'Distribuição',
      },
    },
    numberLengthRange: {
      section: 'Distribuição',
      min: {
        label: 'Tamanho mínimo',
        tooltip: 'Tamanho mínimo dos números gerados.',
      },
      max: {
        label: 'Tamanho máximo',
        tooltip: 'Tamanho máximo dos números gerados.',
      },
    },
    prioritizeQuality: {
      label: 'Priorizar qualidade',
      tooltip:
        'Roda tentativas extras depois da geração principal para tentar melhorar o resultado. Pode demorar mais.',
    },
    numbersList: {
      label: 'Lista de números:',
      copyTooltip: 'Copiar lista para a área de transferência',
    },
    grid: {
      cellLabel: 'Célula linha {row}, coluna {col}',
    },
  },
  sidebar: {
    exportHint: 'Você precisa salvar antes de exportar.',
    defaultFileName: 'numerex',
  },
  button: {
    generate: 'Gerar Jogo',
  },
  alert: {
    gameSaved: 'Jogo salvo com sucesso!',
    cleared: 'Grade limpa com sucesso!',
    generated: 'Numerex gerado com sucesso!',
    generateFailed: 'Não foi possível gerar o Numerex.',
    numberLengthRangeInvalid:
      'Informe um intervalo válido de tamanho de números (mín. ≤ máx.).',
    numbersListCopied: 'Lista de números copiada!',
    numbersListCopyFailed: 'Não foi possível copiar a lista de números.',
    sendSuccess: 'Enviado com sucesso',
    sendError: 'Erro ao enviar. Tente novamente.',
  },
};
